/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetEngineResponse } from '../models/ApiResponseGetEngineResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EngineControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns ApiResponseGetEngineResponse OK
   * @throws ApiError
   */
  public getEngine({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetEngineResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cars/{vin}/engine/',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * @returns ApiResponseGetEngineResponse OK
   * @throws ApiError
   */
  public getEngine1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetEngineResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/cars/{vin}/engine',
      path: {
        'vin': vin,
      },
    });
  }
}
